<template>
  <div>
    <header>
      <slot name="injects"></slot>
      <slot name="question"></slot>
    </header>
    <main>
      <slot name="instruction" class="instruction"></slot>
      <slot name="fields"></slot>
    </main>

  </div>
</template>

<script>
export default {
  name: "QuestionHelper",
}
</script>

<style lang="scss" scoped>

header {
    display: flex;
    // min-height: 100px;
    padding: 20px 25px;

    & > div {
        flex: 1;

        span {
            color: #000;
        }
    }
}
main {
    padding: 0 25px;
}

@media all and (max-width: 767px) {
  header,
  main {
    padding: 20px 15px;
  }
}

.injects {
    position: relative;
    flex: 1;
    max-width: 174px;
    max-height: 113px;
    background-color: #fff;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    i {
        font-size: 34px;
    }

    .count {
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        background-color: #606060;
        color: #fff;
        font-size: 15px;
        padding: 5px;

        i {
            font-size: 15px;
            margin-right: 5px;
        }
    }
}

fieldset {
  border: none;
  padding: 0;

  [type="checkbox"]:checked,
  [type="checkbox"]:not(:checked),
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
      position: absolute;
      left: -9999px;
  }
  [type="checkbox"]:checked + label,
  [type="checkbox"]:not(:checked) + label,
  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label
  {
      position: relative;
      padding-left: 60px;
      cursor: pointer;
      // line-height: 44px;
      display: inline-block;
      color: #3d3dde;
      margin-bottom: 1em;
      width: 100%;

      span {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
      }
      div {
        border-width: 3px;
        padding: 7px;
        width: 100%;
        // max-width: 300px;
        min-height: 44px;
        display: flex;
        align-items: center;
      }
  }
  [type="checkbox"]:checked + label:before,
  [type="checkbox"]:not(:checked) + label:before,
  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 39px;
      height: 39px;
      border: 3px solid #3d3dde;
      border-radius: 100%;
      background: #fff;
      line-height: 44px;
  
  }
  [type="checkbox"]:checked + label:after,
  [type="checkbox"]:not(:checked) + label:after,
  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
      content: "";
      width: 39px;
      height: 39px;
      background: #3d3dde;
      position: absolute;
      top: 3px;
      left: 3px;
      border-radius: 100%;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
  }
  [type="checkbox"]:checked + label:after,
  [type="checkbox"]:not(:checked) + label:after {
    border-radius: 0 !important;
  }
  [type="checkbox"]:checked + label:before,
  [type="checkbox"]:not(:checked) + label:before {
    border-radius: 5px;
  }
  [type="checkbox"]:not(:checked) + label:after,
  [type="radio"]:not(:checked) + label:after {
      opacity: 0;
      -webkit-transform: scale(0);
      transform: scale(0);
  }
  [type="checkbox"]:checked + label:after,
  [type="radio"]:checked + label:after {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
  }
  [type="checkbox"]:checked + label,
  [type="radio"]:checked + label {
    div {
      background-color: #3d3dde;
    }
    div,
    span {
      color: #fff;
    }
  }
}

textarea {
  border: 2px solid #E3E3E3;
  padding: 15px;
  font-size: 14px;

  &:focus {
    border-color: #3d3dde;
    outline: none;
  }
}
</style>